import styled from "styled-components";

export const HomeSaleListWrapper = styled.div`
  width: 50%;
  border-radius: 10px;
  /* background-color: white; */

  @media (max-width: 768px) {
    width: 100%;
  }
`;
